<template>
  <div>
    <div class="row">
      <div class="col">
        <b-button-group>
          <b-button :variant="type === 'all' ? 'success' : ''" @click.prevent="type = 'all'">
            All
          </b-button>
          <b-button :variant="type === 'quotes' ? 'warning' : ''" @click.prevent="type = 'quotes'">
            Quotes
          </b-button>
          <b-button :variant="type === 'invoices' ? 'info' : ''" @click.prevent="type = 'invoices'">
            Invoices
          </b-button>
        </b-button-group>
      </div>
      <div class="col-auto">
        <button
          v-if="$store.state.jobs.currentJob.job_address_id !== null"
          class="btn btn-primary float-right mb-3"
          @click.prevent="createInvoice"
        >
          <font-awesome-icon :icon="['fal', 'plus-circle']" />
          New
        </button>
      </div>

      <div class="w-100"></div>

      <div v-if="$store.state.jobs.currentJob.job_address_id === null" class="col text-muted mt-3">
        Cannot create invoice until the job has a valid job address.
      </div>
    </div>

    <ul class="list-group overflow-y-auto" style="max-height: 708px">
      <!-- eslint-disable -->
      <li v-for="invoice in invoices" v-if="type === 'all' || (type === 'quotes') && invoice.is_quote || (type === 'invoices') && !invoice.is_quote" :key="invoice.id"
          class="list-group-item"
      >
        <div class="row no-gutters">
          <div class="col-auto mr-2">
            <invoice-object :entity-id="invoice.id"
                            :invoice="invoice"
                            :invoice-number="invoice.invoice_number"
                            :open-new="true"/>
          </div>
          <div class="col">
            {{ formatCurrency(invoice.total) }}

            <div class="text-muted mt-0 mb-2">
              {{ formatLocalDate(invoice.created_at) }}
              <span v-if="invoice?.creator?.name">
                 for
                {{ invoice?.creator?.name }}
              </span>

              <span v-if="invoice?.creator?.id !== invoice?.operator?.id && invoice?.operator?.name">
                by {{ invoice?.operator?.name }}
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <template v-if="invoice.is_quote">
              <button v-if="invoice.processed" class="btn btn-info btn-xsm disabled mr-1">
                Processed
              </button>
              <button v-else class="btn btn-info btn-xsm" @click.prevent="process(invoice)">
                Mark Processed
              </button>
            </template>
          </div>
          <div class="col text-right">
            <template v-if="invoice.is_quote">
              <button class="btn btn-success btn-xsm mr-1" @click.prevent="acceptOrPay(invoice)">
                <font-awesome-icon :icon="['fal', 'thumbs-up']"/>
                <span v-if="invoice.accepted" class="px-1">Accepted</span>
                <span v-else class="px-1">Accept</span>
                <font-awesome-icon :icon="['fal', 'share-square']"/>
              </button>
            </template>
            <template v-else>
              <button class="btn btn-success btn-xsm mr-1" @click.prevent="acceptOrPay(invoice)">
                <font-awesome-icon :icon="['fal', 'credit-card']"/>
                <span v-if="invoice.status==='Paid'" class="px-1">Paid</span>
                <span v-else class="px-1">Pay</span>
                <font-awesome-icon :icon="['fal', 'share-square']"/>
              </button>
            </template>

            <button class="btn btn-outline-danger btn-xsm" @click.prevent="send(invoice)">
              <font-awesome-icon :icon="['fal', 'envelope']"/>
              <template v-if="invoice.sent_at"> Resend</template>
              <template v-else> Send</template>
            </button>
          </div>
        </div>
      </li>
    </ul>

    <div v-if="invoices.length === 0">
      <div class="text-muted">
        No Invoice or Quote for this Job.
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import EventBus from "../../../imports/event-bus";
import format from "../../../mixins/format";

export default {
  mixins: [format],

  props: {
    currentJobId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      initialised: false,
      creating: true,
      invoices: [],

      total: null,
      page: null,
      lastPage: null,
      loadingMore: false,

      type: "all",
    };
  },

  watch: {
    currentJobId() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.invoices = [];
      this.type = "all";

      this.$http.get(`/jobs/${this.currentJobId}/invoices?limit=999`).then((response) => {
        this.invoices = response.body.data;

        this.total = response.body.total;
        this.page = response.body.current_page;
        this.lastPage = response.body.last_page;
        this.initialised = true;
      });
    },

    loadMore() {
      if (this.page < this.lastPage) {
        this.loadingMore = true;
        const page = this.page + 1;

        this.$http
          .get(`/jobs/${this.currentJobId}/invoices?page=${page}&limit=10`)
          .then((response) => {
            this.invoices = this.invoices.concat(response.body.data);
            this.page = response.body.current_page;
            this.lastPage = response.body.last_page;

            this.loadingMore = false;
          });
      }
    },

    acceptOrPay(invoice) {
      if (invoice.is_quote) {
        window.open(
          `/invoices/${invoice.uuid}/accept-quote?utm_source=direct&utm_medium=CCT&utm_campaign=DL-Q0`
        );
      } else {
        window.open(
          `/invoices/${invoice.uuid}/pay?utm_source=direct&utm_medium=CCT&utm_campaign=DL-I0`
        );
      }
    },

    process(invoice) {
      return window
        .sweetAlert({
          title: "Are you sure?",
          text: "Please confirm marking the quote as Processed",
          icon: "info",
          dangerMode: true,
          buttons: {
            cancel: "No",
            confirm: "Yes",
          },
        })
        .then((choice) => {
          if (choice) {
            this.$http.put(`/invoices/${invoice.id}/process`).then((response) => {
              if (response.status === 200) {
                window.toastr.success("Quote marked as Processed!", "Success");
                this.init();

                EventBus.$emit("quote-processed", invoice);
              }
            });
          }
        });
    },

    send(invoice) {
      const type = invoice.is_quote ? "quote" : "invoice";

      window
        .sweetAlert({
          title: "Are you sure?",
          text: `Are you sure that you want to send this ${type} to the customer?`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: "No",
            email: "Email Customer",
            sms: "SMS Customer",
          },
        })
        .then((confirmed) => {
          if (confirmed) {
            const channel = confirmed;

            this.$http
              .post(`/invoices/${invoice.id}/${channel}-customer?medium=CCT`)
              .then((response) => {
                const type = invoice.is_quote ? "quote" : "invoice";

                if (response.body.message !== undefined && response.body.message === "success") {
                  window.toastr.success(
                    `Successfully sent this ${type} to ${response.body.recipient.name} via ${channel}.`,
                    "Success"
                  );
                  this.init();

                  EventBus.$emit("invoice-sent", invoice);
                }
              });
          }
        });
    },

    createInvoice() {
      window.open(`/invoices/create/job-id/${this.currentJobId}`);
    },
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.list-group-item {
  padding: 0.75rem;
}
</style>
